// Patches Node.prototype.removeChild and insertBefore to prevent crashes
// when browser translation extensions (Google Translate, etc.) mutate the DOM
// outside of React's control. Without this, React throws:
// "Failed to execute 'insertBefore'/'removeChild' on 'Node'"
if (typeof Node !== 'undefined' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function patchedRemoveChild(...args) {
    if (args[0] && args[0].parentNode !== this) {
      return args[0];
    }
    return originalRemoveChild.apply(this, args);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function patchedInsertBefore(...args) {
    if (args[1] && args[1].parentNode !== this) {
      return args[0];
    }
    return originalInsertBefore.apply(this, args);
  };
}
